<template>
  <modal class="menu" :name="'gallery-modal'" width="100%" height="auto">
    <ListItem icon="eye-blue.svg">{{ $t("app.gallery.visibility") }}</ListItem>
    <ListItem @click.native="$emit('select', 'pub')">
      <span class="pink--text">{{ $t("general.post.visibility-unrestricted") }}</span>
    </ListItem>
    <ListItem @click.native="$emit('select', 'priv')">
      <span class="pink--text">{{ $t("general.post.visibility-restricted") }}</span>
    </ListItem>
  </modal>
</template>
<script>
export default {
  name: "GalleryPrivacyModal"
};
</script>
